import { render, staticRenderFns } from "./EditControls.vue?vue&type=template&id=2326a0d4&"
import script from "./EditControls.vue?vue&type=script&lang=js&"
export * from "./EditControls.vue?vue&type=script&lang=js&"
import style0 from "./EditControls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports